(function () {
  'use strict';

  function updateResponsiveAboutCourse() {
    const screenWidth = window.innerWidth;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      const pdpAboutContentHeading = document.querySelector('.Pdp-About-Content h2');
      if (!pdpAboutContentHeading) return;
      pdpAboutContentHeading.classList.add('text-headline-m-mobile');
      pdpAboutContentHeading.classList.remove('text-headline-m-desktop');

      const pdpAboutCardDatesHeading = document.querySelector('.Pdp-About-Card-Dates-Heading-Wrapper h4');
      if (pdpAboutCardDatesHeading) {
        pdpAboutCardDatesHeading.classList.add('text-headline-s-mobile');
        pdpAboutCardDatesHeading.classList.remove('text-headline-s-desktop');
      }

      const pdpAboutCardRequirementsHeading = document.querySelector('.Pdp-About-Card-Requirements-Heading-Wrapper h4');
      if (pdpAboutCardRequirementsHeading) {
        pdpAboutCardRequirementsHeading.classList.add('text-headline-s-mobile');
        pdpAboutCardRequirementsHeading.classList.remove('text-headline-s-desktop');
      }

      const pdpAboutCardListItems = document.querySelectorAll('.Pdp-About-Card-List-Item');
      pdpAboutCardListItems.forEach((item) => {
        item.classList.add('text-body-s');
        item.classList.remove('text-body-l');
      });
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      const pdpAboutContentHeading = document.querySelector('.Pdp-About-Content h2');
      if (!pdpAboutContentHeading) return;
      pdpAboutContentHeading.classList.add('text-headline-m-mobile');
      pdpAboutContentHeading.classList.remove('text-headline-m-desktop');

      const pdpAboutCardDatesHeading = document.querySelector('.Pdp-About-Card-Dates-Heading-Wrapper h4');
      if (pdpAboutCardDatesHeading) {
        pdpAboutCardDatesHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardDatesHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardRequirementsHeading = document.querySelector('.Pdp-About-Card-Requirements-Heading-Wrapper h4');
      if (pdpAboutCardRequirementsHeading) {
        pdpAboutCardRequirementsHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardRequirementsHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardListItems = document.querySelectorAll('.Pdp-About-Card-List-Item');
      pdpAboutCardListItems.forEach((item) => {
        item.classList.remove('text-body-s');
        item.classList.add('text-body-l');
      });
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      const pdpAboutContentHeading = document.querySelector('.Pdp-About-Content h2');
      if (!pdpAboutContentHeading) return;
      pdpAboutContentHeading.classList.remove('text-headline-m-mobile');
      pdpAboutContentHeading.classList.add('text-headline-m-desktop');

      const pdpAboutCardDatesHeading = document.querySelector('.Pdp-About-Card-Dates-Heading-Wrapper h4');
      if (pdpAboutCardDatesHeading) {
        pdpAboutCardDatesHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardDatesHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardRequirementsHeading = document.querySelector('.Pdp-About-Card-Requirements-Heading-Wrapper h4');
      if (pdpAboutCardRequirementsHeading) {
        pdpAboutCardRequirementsHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardRequirementsHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardListItems = document.querySelectorAll('.Pdp-About-Card-List-Item');
      pdpAboutCardListItems.forEach((item) => {
        item.classList.remove('text-body-s');
        item.classList.add('text-body-l');
      });
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1439) {
      const pdpAboutContentHeading = document.querySelector('.Pdp-About-Content h2');
      if (!pdpAboutContentHeading) return;
      pdpAboutContentHeading.classList.remove('text-headline-m-mobile');
      pdpAboutContentHeading.classList.add('text-headline-m-desktop');

      const pdpAboutCardDatesHeading = document.querySelector('.Pdp-About-Card-Dates-Heading-Wrapper h4');
      if (pdpAboutCardDatesHeading) {
        pdpAboutCardDatesHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardDatesHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardRequirementsHeading = document.querySelector('.Pdp-About-Card-Requirements-Heading-Wrapper h4');
      if (pdpAboutCardRequirementsHeading) {
        pdpAboutCardRequirementsHeading.classList.remove('text-headline-s-mobile');
        pdpAboutCardRequirementsHeading.classList.add('text-headline-s-desktop');
      }

      const pdpAboutCardListItems = document.querySelectorAll('.Pdp-About-Card-List-Item');
      pdpAboutCardListItems.forEach((item) => {
        item.classList.remove('text-body-s');
        item.classList.add('text-body-l');
      });
    }
  }

  updateResponsiveAboutCourse();
  window.addEventListener('resize', updateResponsiveAboutCourse);
})();
